import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 15 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M.907 16.2a.89.89 0 0 1-.645-.257.86.86 0 0 1-.262-.638.88.88 0 0 1 .26-.643.86.86 0 0 1 .64-.262h.3v-6q0-2.175 1.338-3.825t3.463-2.05V1.2q0-.5.35-.85t.85-.35.85.35.35.85v1.325q2.125.4 3.462 2.05T13.2 8.4v6h.3q.384 0 .641.257a.86.86 0 0 1 .26.638.88.88 0 0 1-.26.642.86.86 0 0 1-.64.263zm6.288 3q-.745 0-1.27-.529A1.74 1.74 0 0 1 5.4 17.4H9q0 .75-.53 1.275-.531.525-1.275.525M3 14.4h8.4v-6q0-1.75-1.225-2.975T7.2 4.2 4.225 5.425 3 8.4zm3.3-3.9v1.2q0 .383.257.641a.86.86 0 0 0 .638.259.88.88 0 0 0 .642-.259.87.87 0 0 0 .263-.641v-1.2h1.2a.88.88 0 0 0 .641-.257.86.86 0 0 0 .26-.638.88.88 0 0 0-.26-.643.87.87 0 0 0-.64-.262H8.1V7.5a.87.87 0 0 0-.258-.641.86.86 0 0 0-.638-.26.88.88 0 0 0-.643.26.86.86 0 0 0-.262.64v1.2H5.1a.87.87 0 0 0-.64.258.86.86 0 0 0-.26.638.88.88 0 0 0 .26.642.86.86 0 0 0 .64.263z"
    }, null, -1)
  ]))]))
}
export default { render: render }